import React from "react";
import { Box, Divider, Paper, styled, Typography } from "@material-ui/core";

import { PropertyInfo } from "../../../api/services";
import { MeterPoint } from "./MeterPoint";
import { VulnerabilitiesPanel } from "../../CustomerVulnerabilities/VulnerabilitiesPanel";
import { Agreement } from "./Agreement";
import { MeterPointIcon } from "./MeterPointIcon";
import { PropertyHeader } from "./PropertyHeader";
import { PageLink } from "../../../components/CustomLink";
import { useRouteMatch } from "react-router-dom";

interface PropertyProps {
  property: PropertyInfo;
}

const BoxCell = styled(Box)(({ theme }) => ({
  flex: "1 0 50%",
  whiteSpace: "nowrap",
  paddingLeft: theme.spacing(2),
  paddingBottom: theme.spacing(4.5),
}));

export const Property: React.FC<PropertyProps> = ({ property }) => {
  const { url } = useRouteMatch();

  return (
    <Box
      component={Paper}
      marginBottom={3}
      overflow="hidden"
      data-testid="Property"
    >
      <VulnerabilitiesPanel
        priorityServices={property.priorityServices}
        vulnerabilities={property.vulnerabilities}
      />
      <PropertyHeader address={property.address} p={2} />
      {/* Property Meterpoints */}
      {property.meterPoints.map((mp) => (
        <Box key={mp.id}>
          <Divider />
          <Box display="flex" flexDirection="row" m={2}>
            <Box flexShrink={1}>
              <MeterPointIcon type={mp.type} />
            </Box>
            <Box
              display="flex"
              flexGrow={1}
              flexDirection="row"
              flexWrap="wrap"
            >
              <BoxCell>
                <MeterPoint propertyId={property.id} {...mp} />
              </BoxCell>
              <BoxCell display="flex" flexDirection="column">
                {mp.agreementInfo != null ? (
                  <Agreement agreement={mp.agreementInfo} />
                ) : (
                  <Typography
                    color="textSecondary"
                    data-testid="MeterPoint__Agreement--Empty"
                  >
                    No current agreement
                  </Typography>
                )}
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  mt={2}
                >
                  <PageLink
                    path={`${url}/agreement-history`}
                    text="Agreement history"
                    state={{
                      meterPointId: mp.id,
                    }}
                    data-testid="MeterPoint__Agreement--History"
                  />
                </Box>
              </BoxCell>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
